module.exports = __webpack_public_path__ + "static/media/noticeboard.1c9cad79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/guide/noticeboard.svg
// module id = 581
// module chunks = 0